import { info_icon } from 'constant/AllIcons'
import React from 'react'

const PricingModelToggle = ({ is_business_model, setISBusinessModel }) => {
  return (
    <div className="relative   w-full max-w-full   md:max-w-fit   grid grid-cols-2  p-1 bg-gray-200 rounded">
      <span className="absolute inset-0 m-1 pointer-events-none" aria-hidden="true">
        <span
          className={`absolute inset-0 w-1/2 bg-white rounded shadow transform transition duration-150 ease-in-out ${
            !is_business_model ? 'translate-x-0' : 'translate-x-full'
          }`}
        ></span>
      </span>
      <button
        className={`relative   flex   p-1 px-3 transition duration-150 ease-in-out ${
          is_business_model && 'text-gray-500'
        }`}
        onClick={(e) => {
          e.preventDefault()
          setISBusinessModel(false)
        }}
      >
        <div className=" flex-1 flex flex-col">
          <span className="h3 text-start">SMB</span>{' '}
          <span className="  text-start text-sm"> Self Serve</span>
        </div>
        <div className="ml-1 group">
          <span className=" cursor-pointer">{info_icon}</span>
          <span className=" hidden  absolute group-hover:block bg-gray-600 text-gray-50 text-sm  mt-12 text-start p-2 z-20 rounded-md max-w-xs w-full right-0">
            Our Self Serve plans are made affordable to meet the growing demands of everyone.
          </span>
        </div>
      </button>
      <button
        className={`relative   flex  text-sm font-medium py-1 px-3 transition duration-150 ease-in-out ${
          !is_business_model && 'text-gray-500'
        }`}
        onClick={(e) => {
          e.preventDefault()
          setISBusinessModel(true)
        }}
      >
        <div className=" flex flex-col">
          <span className="h3">Enterprise</span>{' '}
          <span className="  text-start text-sm"> Customised Service</span>
        </div>
        <div className="ml-1 group">
          <span className=" cursor-pointer">{info_icon}</span>
          <span className=" hidden  absolute group-hover:block bg-gray-600 text-gray-50 text-sm  mt-12 text-start p-2 z-20 rounded-md max-w-xs w-full right-0">
            Customised service to meet the needs of enterprises. Everything managed with additional
            services.
          </span>
        </div>
      </button>
    </div>
  )
}

export default PricingModelToggle
